import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";

interface CognitoIdentity {
  name: string;
}

class CwDashboardService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt,
      }
    });
  }
  async getDashboards(): Promise<AxiosResponse<CognitoIdentity>> {
    return await this.client.get("/cwdashboard");
  }

  async getDashboard(url: string): Promise<AxiosResponse<CognitoIdentity>> {
    return await this.client.get("/cwdashboard?url=" + encodeURIComponent(url));
  }
}

export default CwDashboardService;
